import React, { useEffect, useState } from 'react';

export default function Thanks(){
  const [pi, setPi] = useState(null);
  useEffect(()=>{
    const params = new URLSearchParams(window.location.search);
    const paymentIntent = params.get('payment_intent');
    if(paymentIntent) setPi(paymentIntent);
  }, []);
  return (
    <div className="container narrow">
      <h1>Thank you!</h1>
      <p>Your booking is confirmed. A confirmation email and (optionally) a text reminder will be sent shortly.</p>
      {pi && <p className="muted small">Payment Intent: {pi}</p>}
      <a className="btn" href="/">Back to home</a>
    </div>
  );
}
